import type {
  FormModuleComponent,
  Recaptcha,
} from 'services/content/components/types/FormModule'
import * as formService from 'services/form'
import FormModule from 'ui-component-library/components/FormModule'

type Props = {
  components: FormModuleComponent[]
  submitButtonText: string
  submitUrl: string
  recaptcha?: Recaptcha
  invalidText: string
  errorText: string
  successText: string
  styleOverrides?: {
    wrapper: string
    submitButton: string
    component: string
    successText: string
  }
}

function FormModuleContainer({ submitUrl, ...props }: Props) {
  async function handleSubmit(values: Record<string, string>) {
    await formService.submitForm(submitUrl, values)
  }

  return <FormModule {...props} onSubmit={handleSubmit} />
}

export default FormModuleContainer
